export default __webpack_public_path__ + "static/salon-deals-car-pointer~BdeTlCNH-3026c0972ea779e3a442ebf00f2488b9.png";